import { useEffect, useState } from "react";
import { FlaskConical } from "lucide-react";
import { api } from "@/lib/api";

let _cache = null;

/** Which Odoo this deployment talks to — fetched once per page load (open endpoint). */
export function useOdooEnv() {
  const [env, setEnv] = useState(_cache);
  useEffect(() => {
    if (_cache) return;
    api.odooEnv().then((r) => { _cache = r.data; setEnv(r.data); }).catch(() => {});
  }, []);
  return env;
}

/** Full-width warning strip shown whenever the app is connected to a non-production Odoo copy. */
export function SandboxBanner({ compact = false }) {
  const env = useOdooEnv();
  if (!env?.sandbox) return null;
  return (
    <div className={`bg-amber-500 text-black font-bold flex items-center justify-center gap-2 ${compact ? "text-[10px] px-3 py-1" : "text-xs px-4 py-1.5"} sticky top-0 z-40`}
      style={{ backgroundImage: "repeating-linear-gradient(135deg, rgba(0,0,0,0.12) 0 10px, transparent 10px 20px)" }} data-testid="sandbox-banner">
      <FlaskConical size={compact ? 11 : 13} />
      <span>SANDBOX ODOO — {env.host} · {env.db}</span>
      {!compact && <span className="font-normal opacity-80">— scans, planning and sync here do NOT touch production. Switch back in Settings → Odoo Connection.</span>}
    </div>
  );
}
